import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncQuickSeRPFilters = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "quick-serp-filters" */
        /* webpackPreload: true */
        './QuickSeRPFilters'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
